import { Box, Button, Icon } from '@palmetto/palmetto-components';
import { useNavigate } from 'react-router-dom';

import { Flag, MilestoneType } from 'types';

import DateTimeDisplay from '../DateTime';

const milestoneLinkMap: {
  [Key in MilestoneType]?: string;
} = {
  [MilestoneType.noticeToProceed]: 'ntp-package/edit',
  [MilestoneType.install]: 'installation-package/edit',
  [MilestoneType.activation]: 'activation-package/edit',
  [MilestoneType.postActivation]: 'post-activation-package/edit',
};
interface RejectionBannerProps {
  milestone: { type: MilestoneType; name?: string };
  className?: string;
  customViewPathLink?: string;
  flaggedItems?: Flag[];
  rejectedAt?: Date;
}

const getActiveFlags = (flaggedItems?: Flag[]) => {
  if (!flaggedItems) {
    return [];
  }
  return flaggedItems.filter((flag) => !flag.resolved && (flag.flagType || flag.dataKey));
};

const RejectionBannerV2 = ({
  milestone,
  className,
  customViewPathLink,
  flaggedItems,
  rejectedAt,
}: RejectionBannerProps) => {
  const navigate = useNavigate();
  const handleViewNavigate = () => {
    if (customViewPathLink) {
      return navigate(customViewPathLink);
    }
    return navigate(`${milestoneLinkMap[milestone.type]}`);
  };

  const activeFlags = getActiveFlags(flaggedItems);

  return (
    <Box
      borderWidth="xxs"
      borderColor="danger"
      radius="md"
      direction={{ base: 'column', tablet: 'row' }}
      alignItems="stretch"
      fontSize="sm"
      overflow="hidden"
      background="badge-danger"
      shadow="xs"
      height="auto"
      className={className}
    >
      <Box padding="lg" direction="row">
        <Icon name="package-rejected" size="2xl" color="danger" />
      </Box>
      <Box flex="auto" childGap="2xs" padding="lg" fontSize="md" color="danger">
        <Box fontWeight="bold">{milestone.name} Rejected</Box>
        <Box fontWeight="medium">Please review {activeFlags.length} flags to avoid project and payment delays.</Box>
        {rejectedAt ? (
          <Box fontSize="base" direction={{ base: 'column', tablet: 'row' }} childGap="2xs" color="body-primary">
            <DateTimeDisplay fontSize="base" value={rejectedAt.toString()} dateFormat={'DD'} excludeTime />{' '}
            <DateTimeDisplay fontSize="base" value={rejectedAt.toString()} dateFormat="DD" showDuration inline /> ago
          </Box>
        ) : null}
      </Box>
      <Box padding={{ base: '0 lg lg lg', tablet: 'lg' }} justifyContent="center">
        <Button
          as="a"
          variant="primary"
          tone="danger"
          style={{ backgroundColor: 'danger-active' }}
          size={{ base: 'sm', desktop: 'md' }}
          aria-label="view rejected milestone"
          navigate={handleViewNavigate}
        >
          Resolve Flags
        </Button>
      </Box>
    </Box>
  );
};

export default RejectionBannerV2;
